import { render, staticRenderFns } from "./DChip.vue?vue&type=template&id=40451c10"
import script from "./DChip.vue?vue&type=script&lang=js"
export * from "./DChip.vue?vue&type=script&lang=js"
import style0 from "./DChip.vue?vue&type=style&index=0&id=40451c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports